import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformSetPreferredFreelancersOnly } from './set-preferred-freelancers-only.transformer';
import type { SetPreferredFreelancersOnlyCollection } from './set-preferred-freelancers-only.types';

export function setPreferredFreelancersOnlyReducer(
  state: CollectionStateSlice<SetPreferredFreelancersOnlyCollection> = {},
  action: CollectionActions<SetPreferredFreelancersOnlyCollection>,
): CollectionStateSlice<SetPreferredFreelancersOnlyCollection> {
  switch (action.type) {
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'setPreferredFreelancersOnly') {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<SetPreferredFreelancersOnlyCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformSetPreferredFreelancersOnly,
          ),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
